@if (eyebrow || title || text) {
    <sirius-container>
        @if (eyebrow) {
            <span class="sir-card-collection-eyebrow">{{ eyebrow }}</span>
        }
        @if (title) {
            <sirius-heading [text]="title" textStyleCategory="title" textStyleSize="l"></sirius-heading>
        }
        @if (text) {
            <sirius-text-html-paragraph [html]="text" textStyleSize="l"></sirius-text-html-paragraph>
        }
    </sirius-container>
}
